import ApiConfig from "../../Utils/Configs/apiConfig";

export interface UpdateSupplierStatementPayload {
  invoiceId: number;
  supplierId: number;
  invoiceDate: string;
  outstandingBalance: number;
  description: string;
  rowVersion: string;
}

export const UpdateSupplierStatement = async (
  payload: UpdateSupplierStatementPayload,
): Promise<{ success: boolean; message: string }> => {
  try {
    const response = await ApiConfig.getInstance().put(
      "/Invoice/UpdateSupplierStatement",
      payload,
    );
    const responseStatus = Number(response.data?.status?.statusCode);
    const hasResponseStatus = Number.isFinite(responseStatus);
    const failed =
      response.data?.success === false ||
      (hasResponseStatus &&
        (responseStatus < 200 || responseStatus >= 300));

    if (failed) {
      return {
        success: false,
        message:
          response.data?.message ?? "Failed to update supplier statement.",
      };
    }

    return {
      success: true,
      message: response.data?.message ?? "Supplier statement updated.",
    };
  } catch (error) {
    console.error("Failed to update supplier statement:", error);
    return {
      success: false,
      message: "Failed to update supplier statement.",
    };
  }
};
